export const STATE_PROP = 'login'
